import React, { useState } from "react";
import { useRouteLoaderData, defer } from "react-router-dom";
import { getCostsOfAllTicketsByOrgId } from "src/apis/tickets";
import "./reportsHistory.css"; // import css file for styling
import ReportsHistoryMaintenance from "src/components/ReportHistory/reportsHistoryMaintenance";
import ReportsHistoryBudget from "src/components/ReportHistory/reportsHistoryBudget";
import ReportHistoryProjectBudget from "src/components/ReportHistory/reportHistoryProjectBudget";

const ReportsHistory = () => {
  const allReports = useRouteLoaderData("reports-history");
  console.log(allReports);
  const [selectedReport, setSelectedReport] = useState("Maintenance");

  const handleReportClick = (report) => {
    setSelectedReport(report);
  };

  return (
    <div className="reportsHistory">
      <div className="started">
        <h2>Reports History</h2>
      </div>
      <div className="reportHistoryNavbar">
        <ul>
          <li
            style={
              selectedReport === "Maintenance"
                ? { backgroundColor: "#4996EE" }
                : { backgroundColor: "#777A84", color: "black" }
            }
            onClick={() => handleReportClick("Maintenance")}
          >
            Maintenance Report
          </li>
          <li
            style={
              selectedReport === "Budget"
                ? { backgroundColor: "#4996EE" }
                : { backgroundColor: "#777A84", color: "black" }
            }
            onClick={() => handleReportClick("Budget")}
          >
            Budget Report
          </li>
          <li
            style={
              selectedReport === "Project"
                ? { backgroundColor: "#4996EE" }
                : { backgroundColor: "#777A84", color: "black" }
            }
            onClick={() => handleReportClick("Project")}
          >
            Project Budget
          </li>
        </ul>
      </div>
      <div className="reportHistoryContent">
        {selectedReport === "Maintenance" ? (
          <ReportsHistoryMaintenance props={allReports.reports} />
        ) : selectedReport === "Budget" ? (
          <ReportsHistoryBudget />
        ) : selectedReport === "Project" ? (
          <ReportHistoryProjectBudget />
        ) : null}
      </div>
    </div>
  );
};

export default ReportsHistory;

async function loadTicketsWithCosts() {
  const response = await getCostsOfAllTicketsByOrgId();

  return response;
}

export async function loader({ request, params }) {
  return defer({
    reports: await loadTicketsWithCosts(),
  });
}
